var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHighlightVoiceIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#C9C9C9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 10.0527L11 13.0527H8V17.5527H11L14.75 20.5527V10.0527Z",
    stroke: "#C9C9C9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8028 10C22.2088 11.4065 22.9987 13.3138 22.9987 15.3025C22.9987 17.2912 22.2088 19.1985 20.8028 20.605M18.1553 12.6475C18.8583 13.3507 19.2532 14.3044 19.2532 15.2988C19.2532 16.2931 18.8583 17.2468 18.1553 17.95",
    stroke: "#C9C9C9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighlightVoiceIcon);
export default __webpack_public_path__ + "static/media/highlight-voice-icon.90e89428ff0bd3f9affd098bbe58417f.svg";
export { ForwardRef as ReactComponent };